import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavMarketIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.75 8.65999C23.75 8.37999 23.68 8.08999 23.55 7.82999L20.37 1.45999C20.24 1.20999 19.98 1.04999 19.7 1.04999H4.3C4.02 1.04999 3.76 1.20999 3.63 1.45999L0.44 7.83999C0.31 8.09999 0.25 8.37999 0.25 8.66999V9.76999C0.25 10.79 0.68 11.72 1.37 12.44C1.37 12.47 1.35 12.49 1.35 12.52V22.97C1.35 23.38 1.69 23.72 2.1 23.72H21.9C22.31 23.72 22.65 23.38 22.65 22.97V12.52C22.65 12.52 22.64 12.46 22.63 12.43C23.32 11.72 23.75 10.79 23.75 9.76999V8.66999V8.65999ZM1.75 8.65999C1.75 8.60999 1.76 8.54999 1.79 8.49999L4.77 2.54999H19.24L22.22 8.49999C22.25 8.54999 22.26 8.59999 22.26 8.65999V9.75999C22.26 11.17 20.95 12.31 19.34 12.31C17.73 12.31 16.42 11.17 16.42 9.75999C16.42 9.34999 16.08 9.00999 15.67 9.00999C15.26 9.00999 14.92 9.34999 14.92 9.75999C14.92 11.17 13.61 12.31 12 12.31C11.21 12.31 10.46 12.04 9.91 11.54C9.38 11.06 9.08 10.43 9.09 9.75999C9.09 9.34999 8.75 9.00999 8.34 9.00999C7.93 9.00999 7.59 9.34999 7.59 9.75999C7.59 9.77999 7.59 9.79999 7.59 9.80999C7.56 11.19 6.26 12.31 4.67 12.31C3.08 12.31 1.75 11.17 1.75 9.75999V8.65999ZM14.67 22.21H9.32V16.99H14.67V22.21ZM15.92 22.21V16.36C15.92 16.02 15.64 15.74 15.3 15.74H8.7C8.35 15.74 8.08 16.02 8.08 16.36V22.21H2.85V13.44C4.7 14.29 7.25 13.6 8.33 12.01C9.12 13.09 10.47 13.8 12 13.8C13.53 13.8 14.87 13.09 15.67 12.01C16.76 13.6 19.31 14.28 21.15 13.44V22.21H15.92Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavMarketIcon.displayName = 'NavMarketIcon';
